import React from 'react'
import { connect } from 'react-redux'

import Step3View from './Step3View'

const Step3WhatsAppCloudApi = ({ isFetching, currentTemplate, company, variables, options, templates }) => {
  return <Step3View
    info={{
      name: 'WhatsApp Cloud API',
      channel: 'WhatsApp Cloud API',
      provider: 'whatsapp'
    }}
    isFetching={isFetching}
    currentTemplate={currentTemplate}
    company={company}
    variables={variables}
    options={options}
    templates={templates}
  />
}

export default connect()(Step3WhatsAppCloudApi)
